<template>
  <div class="chapter-detail-container" v-wechat-title="chapterContent.bookTitle">

    <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700"/>

    <!--頂部欄-->
    <div id="topContainer" class="top-nav-container" style="position: fixed;top: 0">
      <span id="topTitle" class="title-style">{{ chapterContent.bookTitle }}</span>
      <span id="topBack" @click="backClick" style="position: absolute;left: 10px">返回</span>
      <span id="nightMode" @click="nightMode" style="float: right;margin-right: 10px">夜間</span>
    </div>

    <div id="container" ref="contentContainer" class="textContent-container" @click="checkMiddleClick">

      <!--      <p id="title" style="color: black;font-weight: bold;font-size: 18px;text-align: center">
              {{ currentChapterTitle }}</p>-->

      <p id="content" v-html="chapterHtml" style="line-height: 30px;"></p>

      <div v-show="showReadCoin">
        <p style="font-weight: bold">您的當前賬戶余額：{{ readCoin }}</p>
      </div>

      <div v-show="showUnlockView">
        <div style="width: 100%;height: 1px;background-color: lightgray"></div>

        <!--        <div class="client-download-container" style="margin-top: 20px;margin-bottom: 20px">
                  <a @click="purchase">購買</a>
                </div>-->

        <div style="width: 100%;height: 1px;background-color: lightgray"></div>
      </div>

      <!--未登錄-->
      <div class="noLogin-container" v-show="showLoginView">

        <div style="width: 100%;height: 1px;background-color: lightgray"></div>

        <span @click="register" style="color: #ea477b;font-size: 16px;position: absolute;right: 10px;margin-top: 10px">還沒有賬戶，去註冊</span>

        <div class="input-container" style="margin-top: 40px">
          <img src="../assets/img_phone.png" alt="">
          <input v-model="userName" placeholder="請輸入用戶名">
        </div>

        <div class="input-container" style="margin-top: 20px">
          <img src="../assets/img_confirm_pwd.png" alt="">
          <input type="password" v-model="password" placeholder="請輸入密碼">
        </div>

        <div class="client-download-container">
          <a @click="login">登錄</a>
        </div>

        <div class="client-download-container" style="margin-bottom: 20px;">
          <a @click="startFacebookLogin" style="background-color: dodgerblue">Facebook登錄</a>
        </div>

        <div style="width: 100%;height: 1px;background-color: lightgray"></div>

      </div>

      <!--購買-->
      <div style="margin-top: 30px;margin-bottom: 50px" v-show="showPurchaseView">
        <div style="width: 100%;height: 1px;background-color: lightgray"></div>
        <div class="client-download-container" style="margin-top: 20px;margin-bottom: 20px">
          <a @click="buyChapter">購買當前章節</a>
        </div>
        <div style="width: 100%;height: 1px;background-color: lightgray"></div>

        <div class="client-download-container" style="margin-top: 20px">
          <a @click="buyMoreChapter('10')">購買後10章</a>
        </div>

        <div class="client-download-container">
          <a @click="buyMoreChapter('50')">購買後50章</a>
        </div>

        <div class="client-download-container">
          <a @click="buyMoreChapter('100')">購買後100章</a>
        </div>

        <div class="client-download-container" style="margin-bottom: 20px">
          <a @click="buyMoreChapter('all')">購買全部</a>
        </div>
        <div style="width: 100%;height: 1px;background-color: lightgray"></div>

      </div>

      <!--客戶端下載-->
      <!--      <div @click="jumpDownloadView" class="client-download-container">
              <a>點擊下載立異app</a>
            </div>-->
      <div ref="bottomMarker"></div>

    </div>

    <!--上壹章 下壹章-->
    <div id="bottomContainer" class="button-container" v-show="showBottomContainer">
      <!--
            <img class="button-style" @click="afterChapter" src="../assets/img_pre_chapter.png" v-if="showAfterButton">
      -->
      <img class="button-style" @click="lookCatalog" src="../assets/img_catalog.png">
      <!--
            <img class="button-style" @click="nextChapter" src="../assets/img_next_chapter.png" v-if="showNextButton">
      -->
    </div>

    <!-- 鎖定底部 下載按鈕 -->
    <div class="mybutton">
      <h5>下載立異APP，暢讀海量小說</h5>
      <img @click="justGotoDownLoad" src="../assets/openNowButton_font.png">
    </div>

  </div>
</template>

<script>
import axios from "axios";

let _this;

export default {
  name: "ChapterDetailVue",
  components: {},
  data() {
    return {
      showBottomContainer: false,
      userId: "",
      token: "",
      userName: "",
      password: "",
      bookId: "",
      currentChapterId: "",
      chapterContent: [],
      currentChapterTitle: "",
      chapterHtml: "",
      showAfterButton: false,
      showNextButton: false,
      nextId: 0,
      preId: 0,
      forwardId: "",
      showReadCoin: false,
      readCoin: "0",
      chapterPrice: "0",
      isRequest: false,
      isLogin: false,
      showLoginView: false,
      showPurchaseView: false,
      showUnlockView: false,
      nightModeStatus: "false",
      clientDownloadUrl:
        "https://play.google.com/store/apps/details?id=com.mysread.mys",
      isLoading: false, // 用於防止重復加載
      loadMoreTimer: null,
      onScroll: null,
      preScrollHeight: 0,
      previousScrollTop: 0,
      scrollHeight: 0,
      scrollTop: 0,
      startY: 0, // Store the starting Y position of touch
      lastY: 0, // Store the last Y position of touch
      lastScrollPosition: 0, // 記錄上次滾動位置
      isUpLoading: false, // 用於防止重復加載

    };
  },
  methods: {
    checkMiddleClick(event) {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // 計算視口中心點
      const centerX = viewportWidth / 2;
      const centerY = viewportHeight / 2;

      // 計算點擊位置相對於視口的坐標（減去滾動偏移）
      const clickX = event.clientX + window.scrollX;
      const clickY = event.clientY + window.scrollY;

      // 定義中間區域的寬度和高度（例如，視口寬高的1/3）
      const middleWidth = viewportWidth / 3;
      const middleHeight = viewportHeight / 3;

      // 判斷點擊位置是否在中間區域內
      if (
        clickX >= centerX - middleWidth / 2 &&
        clickX <= centerX + middleWidth / 2 &&
        clickY >= centerY - middleHeight / 2 &&
        clickY <= centerY + middleHeight / 2
      ) {
        console.log('點擊了頁面視口中間那塊區域！');
        // 執行相關邏輯
        this.showBottomContainer = !this.showBottomContainer
      } else {
        console.log('未點擊頁面視口中間那塊區域。');
      }

    },
    justGotoDownLoad() {
      this.$router.push({
        path: "DownloadVue",
        query: {
          bookId: this.bookId,
          chapterId: this.currentChapterId,
          bookName: this.chapterContent.bookTitle,
        },
      });
    },
    handleTouchMove(event) {
      this.lastY = event.touches[0].clientY;
    },
    handleTouchEnd() {
      const deltaY = this.lastY - this.startY;
      if (deltaY > 0 && this.isNearBottom() && !this.isLoading) {
        // Load more content
        this.isLoading = true;
        // 加載內容前記錄滾動位置
        this.scrollPosition = this.$refs.contentContainer.scrollTop;
        this.nextChapter();
      }
      // 獲取滾動容器的DOM元素
      /*const scrollContainer = this.$refs.contentContainer;
      // 判斷滾動位置是否接近頂部
      if (scrollContainer.scrollTop < 100 && !this.isUpLoading) { // 這裏的100是壹個閾值，妳可以根據實際情況調整
        // 觸發加載前壹章內容的方法
        this.isUpLoading = true;
        this.afterChapter();
      }*/
    },
    isNearBottom() {
      const bottomMarker = this.$refs.bottomMarker;
      const rect = bottomMarker.getBoundingClientRect();
      return rect.top <= window.innerHeight;
    },
    //返回
    backClick: function () {
      this.$router.push({
        path: "BookDetailVue",
        query: {
          bookId: this.bookId,
          vueName: "SelectedVue",
        },
      });
    },

    //獲取章節詳情
    getChapterDetail: function (chapterId) {
      console.log("獲取章節詳情用戶id: " + this.userId);
      this.isRequest = true;
      this.currentChapterId = chapterId;
      const params = new URLSearchParams();
      params.append("language", "zh-Hant");
      params.append("dev", "h5");
      params.append("uuid", "123456");
      params.append("ver", "1.0");
      params.append("ac", "read");
      params.append("bookId", this.bookId);
      params.append("uid", this.userId);
      params.append("chapterId", chapterId);
      this.$http.post(axios.baseURL, params).then((res) => {
        if (res.data.status) {
          this.setChapterContent(res);
        } else {
          alert(res.data.msg);
        }
      });
    },

    //設置章節內容
    setChapterContent(res) {
      this.setCookie();
      window.scrollTo(0, -1);
      this.showLoginView = false;
      this.showPurchaseView = false;
      this.chapterContent = res.data.data;
      this.readCoin = res.data.zhye + "";
      this.chapterPrice = this.chapterContent.chapterPrice + "";
      if (this.chapterContent.chapterTitle !== null) {
        this.currentChapterTitle = this.chapterContent.chapterTitle;
      }
      if (typeof res.data.prevChapterId !== "undefined") {
        this.showAfterButton = true;
        this.preId = res.data.prevChapterId;
      } else {
        this.showAfterButton = false;
      }
      if (typeof res.data.nextChapterId !== "undefined") {
        this.showNextButton = true;
        this.nextId = res.data.nextChapterId;
      } else {
        this.showNextButton = false;
      }
      if (this.chapterContent.chapterStatus) {
        this.showReadCoin = false;
        this.showUnlockView = false;
      } else {
        this.showReadCoin = this.isLogin;
        this.showUnlockView = true;
      }
      this.aesDecrypt(
        this.chapterContent.chapterId,
        this.chapterContent.chapterHtml,
        this.chapterContent.chapterStatus
      );
    },

    //Aes解密
    aesDecrypt: function (chapterId, content, chapterStatus) {
      let code = this.$cryptoJS.MD5(chapterId).toString();
      let iv = this.$cryptoJS.enc.Utf8.parse(code.substring(0, 16));
      let key = this.$cryptoJS.enc.Utf8.parse(code.substring(16));
      //瀑布流設置
      const chapterHtml = this.$cryptoJS.AES.decrypt(content, key, {
        iv: iv,
        padding: this.$cryptoJS.pad.Pkcs7,
      }).toString(this.$cryptoJS.enc.Utf8).toString()
        .replace(/<p>/g, "<p>&nbsp;&nbsp;&nbsp;&nbsp;");
      const title = "<p style=\"color: black;font-weight: bold;font-size: 18px;text-align: center\">" + this.chapterContent.chapterTitle + "</p>";

      //瀑布流設置
      if (this.isUpLoading) {
        this.chapterHtml = title + chapterHtml + this.chapterHtml
        this.isUpLoading = false;
        // 加載完內容後將滾動位置設置為之前記錄的位置
        this.$nextTick(() => {
          this.$refs.contentContainer.scrollTop = 5;
        });
      } else {
        const line = "<div style=\"border-bottom: 1px dashed #000; width: 100%; height: 0; line-height: 0; margin: 0; padding: 0;\"></div>";
        if (chapterStatus) {
          this.chapterHtml = this.chapterHtml + title + chapterHtml + line;
        } else {//需付費
          const gotoDownLoad = "<a href='javascript:void(0)' onclick='window_justGotoDownLoad()' style='display:block;text-align: center;margin: auto; width: 60%;background-color: yellow;border: 1px solid #000;border-radius: 5px;'>打開立異APP暢讀全文</a>";
          this.chapterHtml = this.chapterHtml + title + chapterHtml + gotoDownLoad + line;
        }
        this.isLoading = false;
        // 加載完內容後將滾動位置設置為之前記錄的位置
        this.$nextTick(() => {
          this.$refs.contentContainer.scrollTop = this.scrollPosition;
        });
        this.isRequest = false;
      }

    },

    //購買
    purchase: function () {
      this.showUnlockView = false;
      console.log("是否登錄: " + this.isLogin);
      if (this.isLogin) {
        this.showLoginView = false;
        if (parseInt(this.readCoin) > 0) {
          this.showPurchaseView = true;
        } else {
          this.$router.push({
            path: "StartRechargeVue",
            query: {
              bookId: this.bookId,
              chapterId: this.currentChapterId,
            },
          });
        }
      } else {
        this.showLoginView = true;
        this.showPurchaseView = false;
      }
    },

    buyChapter: function () {
      if (this.userId !== null && this.userId !== "null") {
        this.isRequest = true;
        const params = new URLSearchParams();
        params.append("language", "zh-Hant");
        params.append("dev", "h5");
        params.append("uuid", "123456");
        params.append("ver", "1.0");
        params.append("ac", "buyBook");
        params.append("bookId", this.bookId);
        params.append("uid", this.userId);
        params.append("chapterId", this.currentChapterId);
        this.$http.post(axios.baseURL, params).then((res) => {
          this.isRequest = false;
          if (res.data.status) {
            this.getChapterDetail(this.currentChapterId);
          } else {
            this.$router.push({
              path: "StartRechargeVue",
              query: {
                bookId: this.bookId,
                chapterId: this.currentChapterId,
              },
            });
          }
        });
      }
    },

    //批量購買章節
    buyMoreChapter: function (flag) {
      if (this.userId !== null && this.userId !== "null") {
        this.isRequest = true;
        const params = new URLSearchParams();
        params.append("language", "zh-Hant");
        params.append("dev", "h5");
        params.append("uuid", "123456");
        params.append("ver", "1.0");
        params.append("ac", "buyBookNext");
        params.append("bookId", this.bookId);
        params.append("uid", this.userId);
        params.append("chapterId", this.currentChapterId);
        params.append("flag", flag);
        this.$http.post(axios.baseURL, params).then((res) => {
          this.isRequest = false;
          if (res.data.status) {
            this.getChapterDetail(this.currentChapterId);
          } else {
            this.$router.push({
              path: "StartRechargeVue",
              query: {
                bookId: this.bookId,
                chapterId: this.currentChapterId,
              },
            });
          }
        });
      }
    },

    //登錄
    login: function () {
      if (this.userName === null || this.userName === "") {
        alert("請輸入用戶名");
        return;
      }
      if (this.password === null || this.password === "") {
        alert("請輸入密碼");
        return;
      }
      localStorage.setItem("userName", this.userName);
      localStorage.setItem("pwd", this.password);
      this.isRequest = true;
      const params = new URLSearchParams();
      params.append("language", "zh-Hant");
      params.append("dev", "h5");
      params.append("uuid", "123456");
      params.append("ver", "1.0");
      params.append("ac", "login");
      params.append("mobile", this.userName);
      params.append("pwd", this.password);
      this.$http.post(axios.baseURL, params).then((res) => {
        this.isRequest = false;
        if (res.data.status) {
          this.isLogin = true;
          let loginData = res.data.data;
          this.userId = loginData.id;
          localStorage.setItem("userId", loginData.id);
          localStorage.setItem("token", loginData.token);
          this.getChapterDetail(this.currentChapterId);
        } else {
          alert(res.data.msg);
        }
      });
    },

    //註冊
    register: function () {
      this.$router.push({
        path: "RegisterVue",
        query: {
          vueName: "ChapterDetailVue",
          bookId: this.bookId,
          chapterId: this.currentChapterId,
        },
      });
    },

    //上壹章
    afterChapter: function () {
      this.jumpDownloadView(this.preId);
      //this.getChapterDetail(this.preId);
    },

    //下壹章
    nextChapter: function () {
      this.jumpDownloadView(this.nextId);
      //this.getChapterDetail(this.nextId);
    },

    //目錄
    lookCatalog: function () {
      this.$router.push({
        path: "CatalogVue",
        query: {
          bookId: this.bookId,
          bookName: this.chapterContent.bookTitle,
        },
      });
    },

    //保存當前當前書籍章節信息id
    setCookie: function () {
      localStorage.setItem(this.bookId, this.currentChapterId);
    },

    startFacebookLogin: function () {
      FB.login(
        function (response) {
          if (response.status === "connected") {
            console.log("開始facebook登錄");
            _this.facebookLoginSuccess();
          } else {
            alert("Facebook登錄失敗");
          }
        },
        {scope: "public_profile,email"}
      );
    },

    facebookLoginSuccess: function () {
      FB.api("/me", function (response) {
        const requestUrl = "https://b.mysread.com/api6.php";
        const params = new URLSearchParams();
        params.append("language", "zh-Hant");
        params.append("dev", "h5");
        params.append("uuid", "123456");
        params.append("ver", "1.0");
        params.append("ac", "otherLogin");
        params.append("nicheng", response.name);
        params.append("unionid", response.id);
        params.append("type", "facebook");
        params.append("openid", response.id);
        _this.isRequest = true;
        _this.$http.post(requestUrl, params).then((res) => {
          _this.isRequest = false;
          if (res.data.status) {
            let loginData = res.data.data;
            console.log("facebook登錄成功");
            console.log(loginData);
            localStorage.setItem("userId", loginData.id);
            localStorage.setItem("token", loginData.token);
            _this.token = loginData.token;
            _this.userId = loginData.id;
            _this.getUserMessage();
          } else {
            alert(res.data.msg);
          }
        });
      });
    },

    //獲取用戶信息
    getUserMessage: function () {
      console.log("開始獲取用戶信息");
      this.isRequest = true;
      const params = new URLSearchParams();
      params.append("language", "zh-Hant");
      params.append("dev", "h5");
      params.append("uuid", "123456");
      params.append("ver", "1.0");
      params.append("ac", "getUsr");
      params.append("uid", this.userId);
      params.append("token", this.token);
      this.$http.post(axios.baseURL, params).then((res) => {
        this.isRequest = false;
        if (res.data.status) {
          console.log("獲取用戶信息成功,開始獲取章節詳情");
          _this.isLogin = true;
          this.getChapterDetail(this.currentChapterId);
        } else {
          console.log("獲取用戶信息失敗: " + res.data.msg);
          localStorage.setItem("userId", null);
          localStorage.setItem("token", null);
          this.userId = null;
          this.token = null;
        }
      });
    },

    //夜間模式
    nightMode: function () {
      if (this.nightModeStatus === "true") {
        this.nightModeStatus = "false";
        document.getElementById("nightMode").innerText = "日間";
        document.getElementById("container").style.backgroundColor =
          "#111111";
        document.getElementById("topContainer").style.backgroundColor =
          "#2a2a2a";
        document.getElementById(
          "bottomContainer"
        ).style.backgroundColor = "#111111";
        document.getElementById("content").style.color = "#939393";
        document.getElementById("title").style.color = "#939393";
        document.getElementById("topBack").style.color = "#939393";
        document.getElementById("topTitle").style.color = "#939393";
        document.getElementById("nightMode").style.color = "#939393";
      } else if (this.nightModeStatus === "false") {
        this.nightModeStatus = "true";
        document.getElementById("nightMode").innerText = "夜間";
        document.getElementById("container").style.backgroundColor =
          "#cce9cb";
        document.getElementById("topContainer").style.backgroundColor =
          "#f2c510";
        document.getElementById(
          "bottomContainer"
        ).style.backgroundColor = "#cce9cb";
        document.getElementById("content").style.color = "black";
        document.getElementById("title").style.color = "black";
        document.getElementById("topBack").style.color = "black";
        document.getElementById("topTitle").style.color = "black";
        document.getElementById("nightMode").style.color = "black";
      }
    },

    //跳轉到下載界面
    jumpDownloadView: function (goId) {
      if (this.forwardId) {
        if (this.forwardId.indexOf(goId) == -1) {//goId不包含在查到的ID中則跳下載頁
          fbq("track", "preDownload");
          _lt('send', 'cv', {
            type: 'preDownload'
          }, ['da099686-7375-45bd-9b84-e87f95c05af4']);
          ttq.track('preDownload')

          this.$alert(`網頁版篇幅有限，下載APP繼續閱讀後續精彩內容<br>點擊“確定”按鈕，前往應用商店選擇頁`, '溫馨提示', {
            confirmButtonText: '確定',
            showClose: false,
            dangerouslyUseHTMLString: true,
            center: true,
            callback: action => {
              this.$router.push({
                path: "DownloadVue",
                query: {
                  bookId: this.bookId,
                  chapterId: this.currentChapterId,
                  bookName: this.chapterContent.bookTitle,
                },
              });
            }
          });
        } else {
          this.getChapterDetail(goId);
        }
      } else {//forwardId不存在，只允許看3章
        let canRead = localStorage.getItem("canRead_" + this.bookId);
        if (canRead != null && typeof (canRead) !== 'undefined' && canRead !== '') {
          canRead = JSON.parse(canRead);
        } else {
          canRead = [];
        }
        canRead.push(goId);
        localStorage.setItem("canRead_" + this.bookId, JSON.stringify(canRead));
        if (process.env.LIMIT_READ === '0' && canRead.length > 3) {
          //允許看已經超過3章，跳下載頁
          fbq("track", "preDownload");
          _lt('send', 'cv', {
            type: 'preDownload'
          }, ['da099686-7375-45bd-9b84-e87f95c05af4']);
          ttq.track('preDownload')
          this.$alert(`網頁版篇幅有限，下載APP繼續閱讀後續精彩內容<br>點擊“確定”按鈕，前往應用商店選擇頁`, '溫馨提示', {
            confirmButtonText: '確定',
            showClose: false,
            dangerouslyUseHTMLString: true,
            center: true,
            callback: action => {
              this.$router.push({
                path: "DownloadVue",
                query: {
                  bookId: this.bookId,
                  chapterId: this.currentChapterId,
                  bookName: this.chapterContent.bookTitle,
                },
              });
            }
          });
        } else {
          this.getChapterDetail(goId);
        }
      }
    },
    getForwardByChapter: function () {
      const params = new URLSearchParams();
      params.append("language", "zh-Hant");
      params.append("dev", "h5");
      params.append("ver", "1.0");
      params.append("ac", "getForwardByChapter");
      params.append("chapterId", this.currentChapterId);
      this.$http.post(axios.baseURL, params).then((res) => {
        this.isRequest = false;
        if (res.data.status) {
          this.forwardId = res.data.data;
        } else {
        }
      });
    }
  }
  ,

  created() {
    _this = this;
    this.$nextTick(() => {
      // 禁用右鍵
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用選擇
      document.onselectstart = new Function("event.returnValue=false");
    });
    this.userId = localStorage.getItem("userId");
    this.bookId = this.$route.query.bookId;
    this.currentChapterId = this.$route.query.chapterId;
    this.isLogin = !(this.userId === null || this.userId === "null");
    this.getChapterDetail(this.currentChapterId);
    this.getForwardByChapter()
  }
  ,
  destroyed() {
    window.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('touchend', this.handleTouchEnd);

  }
  ,
  mounted: function () {
    window.addEventListener('touchmove', this.handleTouchMove);
    window.addEventListener('touchend', this.handleTouchEnd);
    window.window_justGotoDownLoad = this.justGotoDownLoad;
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      FB.init({
        appId: "445792245804186",
        cookie: true, // 啟用cookie
        xfbml: true, // 解析此頁面上的社交插件
        version: "v2.8", // 使用圖形api 2.8版本
      });
    };


    //facebook像素
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    fbq("init", "1025830745421256");
    //fbq("track", "PageView");

    //line像素
    (function (g, d, o) {
      g._ltq = g._ltq || [];
      g._lt = g._lt || function () {
        g._ltq.push(arguments)
      };
      var h = location.protocol === 'https:' ? 'https://d.line-scdn.net' : 'http://d.line-cdn.net';
      var s = d.createElement('script');
      s.async = 1;
      s.src = o || h + '/n/line_tag/public/release/v1/lt.js';
      var t = d.getElementsByTagName('script')[0];
      t.parentNode.insertBefore(s, t);
    })(window, document);
    _lt('init', {
      customerType: 'lap',
      tagId: 'da099686-7375-45bd-9b84-e87f95c05af4'
    });
    _lt('send', 'pv', ['da099686-7375-45bd-9b84-e87f95c05af4']);
    //轉換代碼
    /*_lt('send', 'cv', {
      type: 'Conversion'
    }, ['da099686-7375-45bd-9b84-e87f95c05af4']);
    _lt('send', 'cv', {
      type: 'goDownload'
    }, ['da099686-7375-45bd-9b84-e87f95c05af4']);*/

    //tk像素
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"], ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
        }
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e
      }, ttq.load = function (e, n) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
        var o = document.createElement("script");
        o.type = "text/javascript", o.async = !0, o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a)
      };
      ttq.load('CLULPKRC77UDM51DRCEG');
      ttq.page();
    }(window, document, 'ttq');
    //ttq.track('Download')

  }
  ,
}
;
</script>
<noscript>
<img height="1" width="1" style="display:none"
     src="https://www.facebook.com/tr?id=1025830745421256&ev=PageView&noscript=1"/>
<img height="1" width="1" style="display:none"
     src="https://tr.line.me/tag.gif?c_t=lap&t_id=da099686-7375-45bd-9b84-e87f95c05af4&e=pv&noscript=1"/>
</noscript>

<style scoped>
.chapter-detail-container {
  max-width: 480px;
  min-height: calc(90vh);
  margin: 0 auto;
  background-color: #cce9cb;
}

.title-style {
  font-weight: bold;
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
  margin-left: 25%;
}

.textContent-container {
  text-align: left;
  margin-top: 50px;
  margin-bottom: 35px;
  padding: 10px 5px;
  min-height: 90vh;
  overflow-y: scroll; /*瀑布流設置*/
  height: 500px; /*瀑布流設置*/
}

#content:after { /*瀑布流設置*/
  content: "";
  display: block;
  height: 30px;
}

.textContent-container p {
  font-size: 18px;
  line-height: 40px;
  -webkit-line-clamp: 1000;
}

.button-container {
  position: fixed;
  height: 35px;
  bottom: 35px;
  width: 100%;
  max-width: 480px;
  background-color: #cce9cb;
}

.button-style {
  height: 35px;
  width: 32%;
  background: #fc9504;
  border: 1px solid #fc9504;
  color: white;
  padding: 5px 30px;
  font-size: 14px;
  font-family: 楷體;
  border-radius: 3px;
}

.button-style:active {
  transform: scale(0.9);
}

.client-download-container {
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;
  display: flex;
  flex-direction: column;
}

.client-download-container a {
  margin-top: 10px;
  height: 30px;
  background-color: firebrick;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  color: white;
  line-height: 30px;
}

.client-download-container a:active {
  background-color: gray;
}

.noLogin-container {
  text-align: center;
  margin-bottom: 50px;
  margin-top: 30px;
}

.input-container {
}

.input-container input {
  width: 70%;
  height: 30px;
  padding-left: 10px;
  outline: none;
  border: 1px solid gray;
  border-radius: 5px;
  color: black;
  font-size: 14px;
}

/*鎖定底部,下載按鈕*/
.mybutton {
  position: fixed;
  height: 35px;
  bottom: 0;
  width: 100%;
  max-width: 480px;
  background-image: url(../assets/bottomColor.png);

  display: flex;
  justify-content: space-between; /* 使元素左右對齊，之間有空隙 */
}

.mybutton img {
  max-width: 50%; /* 根據需要調整圖片的最大寬度 */
  height: 80%; /* 保持圖片的寬高比 */
}

/*鎖定底部,下載按鈕*/
</style>



// WEBPACK FOOTER //
// src/components/ChapterDetailVue_PB.vue